module.exports = global["bf"] = require("-!/builds/360psg/blank/savannah/node_modules/babel-loader/lib/index.js??ref--0!./index.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?bf!./src/frontend/index.js-exposed
// module id = 119
// module chunks = 6